import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
// import { InfoDialogComponent } from '../../../views/info-dialog/info-dialog.component';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  public loginUrl: boolean;
  constructor(
    private router: Router,
    private dialog: MatDialog
  ) {
    if (this.router.url.includes('/login')) this.loginUrl = true;
  }

  ngOnInit() { }

  // showInfo() {
  //   this.dialog.open(InfoDialogComponent, {
  //     width: '250px',
  //   });
  // }

}
